import type { CSSProperties, ReactNode } from 'react'

export interface FABProps {
  icon: ReactNode
  onClick: () => void
  ariaLabel: string
}

export function FAB({ icon, onClick, ariaLabel }: FABProps) {
  const style: CSSProperties = {
    position: 'fixed',
    right: 'var(--space-4)',
    bottom: 'calc(var(--nav-height-mobile) + var(--space-4) + env(safe-area-inset-bottom, 0))',
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: 'var(--color-text)',
    color: 'var(--color-bg)',
    border: 'none',
    fontSize: 24,
    fontWeight: 800,
    boxShadow: 'var(--shadow-md)',
    cursor: 'pointer',
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
  return (
    <button type="button" style={style} onClick={onClick} aria-label={ariaLabel}>
      {icon}
    </button>
  )
}
